module.exports = __webpack_public_path__ + "exo-latin-800italic.e75d9cbb1468c3156c59.woff2";


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/typeface-exo/files/exo-latin-800italic.woff2
// module id = ../../../../typeface-exo/files/exo-latin-800italic.woff2
// module chunks = styles